export default { sha: '5278ed7aedd2920ffa3c11e863d5979bbee82a35', buildNumber: 'undefined' }
